export default function (instance) {
  const getWBSCodeOriginal = instance.getWBSCode;

  instance.getWBSCode = function (task) {
    const wbs = getWBSCodeOriginal.apply(this, arguments);

    if (!wbs) {
      return '';
    }

    let resultWBS = wbs.substring(wbs.indexOf('.') + 1);

    if (instance.config.multiview) {
      if (instance.calculateTaskLevel(task) === 1) {
        return '';
      }

      resultWBS = resultWBS.substring(resultWBS.indexOf('.') + 1);
    }

    return resultWBS;
  };

  instance.getWBSCodeOriginal = getWBSCodeOriginal;
}
